<form class="program-open-text card">
  <h4>{{ programNode?.labelText }}</h4>
  <span
    class="label-highlight"
    *ngIf="programNode?.description"
    [innerHTML]="programNode?.description"
  ></span>

  <div class="program-open-text__input-container">
    <ng-container *ngFor="let grp of formArray.controls; let i = index">
      <div class="program-open-text__row">
        <input
          [formControl]="getFormControl(grp.get('key'))"
          class="field__input field__input--sm"
          [type]="inputKey?.type === 'number' ? 'number' : 'text'"
          [placeholder]="inputKey?.labelText || ''"
        />

        <input
          [formControl]="getFormControl(grp.get('value'))"
          class="field__input field__input--sm"
          [type]="inputValue?.type === 'number' ? 'number' : 'text'"
          [placeholder]="inputValue?.labelText || ''"
        />

        <button
          *ngIf="formArray.length > 1"
          type="button"
          class="btn btn--icon btn--ssm program-open-text__remove-button"
          (click)="remove(i)"
          aria-label="Remove"
        >
          <i class="fa-solid fa-trash program-open-text__remove-icon"></i>
        </button>
      </div>
    </ng-container>
  </div>

  <div class="program-open-text__actions">
    <button type="button" class="btn btn--sm btn--outline" (click)="addMore()">
      <i class="fa-solid fa-plus"></i>
      <span>{{ 'ADD_MORE' | translate }}</span>
    </button>
  </div>
</form>
